<template>
  <v-stepper
    v-model="passoAtual"
    class="mt-2 mt-md-5"
    style="box-shadow: none;"
  >
    <v-stepper-header
      class="grey lighten-3"
      style="box-shadow: none;"
    >
      <template v-for="(item, index) in quantDePassos">
        <v-stepper-step
          :key="'step_' + index"
          :step="item.step"
          :complete="passoAtual > item.step"
          complete-icon="check"
          :data-cy="'passo_marcador_' + item.step"
        />

        <v-divider
          v-if="quantDePassos.length > item.step"
          :key="'divider_' + index"
        />
      </template>
    </v-stepper-header>

    <v-stepper-items
      class="grey lighten-3"
    >
      <template v-for="(item, index) in quantDePassos">
        <v-stepper-content
          :key="'content_' + index"
          :step="item.step"
          :class="$vuetify.breakpoint.smAndDown ? 'height-content' : ''"
          class="pa-0"
        >
          <PassoDadosPessoais
            v-if="item.step === 1"
            class="mb-md-12"
            @formValidado="ativarPasso($event,index)"
          />
          <PassoDadosBancarios
            v-if="item.step === 2"
            class="mb-md-5"
            @formValidado="ativarPasso($event,index)"
          />
          <PassoFaltaPouco
            v-if="item.step === 3"
            class="mb-md-4"
            @formValidado="ativarPasso($event,index)"
          />

          <div
            :class="$vuetify.breakpoint.mdAndUp
              ? 'botoes-rodape--desktop' : 'botoes-rodape--mobile botoes-rodape--stepper'"
            class="botoes-rodape pa-3 pa-md-0 px-md-0"
          >
            <BtnVoltar
              :key="'voltar_' + index"
              :index="item.step"
              @irParaAnterior="novoValor => passoAtual = novoValor"
            />

            <BtnProsseguir
              v-if="item.step < 3"
              :key="'prosseguir_' + index"
              :index="item.step"
              :desabilitar-btn="item.possuiValidacao"
              :nao-proseguir="item.msgConfirmacao"
              @irParaProximo="novoValor => passoAtual = novoValor"
              @naoIrParaProximo="confirmacao => dialogConfirmacao = confirmacao"
            />

            <BtnSalvar
              v-else
              :desabilitar-btn="item.possuiValidacao"
              :dados-conta="dadosConta"
              @respostaApi="respostaApi"
            />

            <ModalConfirmacaoDados
              v-if="item.step === 2"
              :index="item.step"
              :dialog="dialogConfirmacao"
              :dados-pessoais="quantDePassos[0]"
              :dados-bancarios="quantDePassos[1]"
              @changeDialog="dialog => dialogConfirmacao = dialog"
              @infoVerificadas="novoValor => passoAtual = novoValor"
            />
          </div>
          <SnackBar
            :mensage="snackBar.message"
            :snackbar="snackBar.show"
            :button="true"
            :color="snackBar.color"
            :timeout="snackBar.timeout"
            @changeSnackBar="redirecionaLista"
          />
        </v-stepper-content>
      </template>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import PassoDadosPessoais from '@/components/SolicitacaoReembolso/Boleto/PassoDadosPessoais.vue';
import PassoDadosBancarios from '@/components/SolicitacaoReembolso/Boleto/PassoDadosBancarios.vue';
import PassoFaltaPouco from '@/components/SolicitacaoReembolso/Boleto/PassoFaltaPouco.vue';
import BtnProsseguir from '@/components/Steppers/BtnProsseguir.vue';
import BtnVoltar from '@/components/Steppers/BtnVoltar.vue';
import BtnSalvar from '@/components/MeuPerfil/ContasBancarias/BtnSalvar.vue';
import ModalConfirmacaoDados from '@/components/SolicitacaoReembolso/Boleto/ModalConfirmacaoDados.vue';
import SnackBar from '@/components/SnackBar.vue';

export default {
  name: 'ContasStepper',

  components: {
    PassoDadosPessoais,
    PassoDadosBancarios,
    PassoFaltaPouco,
    BtnProsseguir,
    BtnSalvar,
    BtnVoltar,
    SnackBar,
    ModalConfirmacaoDados,
  },

  data() {
    return {
      passoAtual: 1,
      btAtualDisabled: true,
      dadosConta: {},
      dialog: false,
      dialogConfirmacao: false,
      quantDePassos: [
        {
          step: 1, form: {}, possuiValidacao: true, msgConfirmacao: false,
        },
        {
          step: 2, form: {}, possuiValidacao: true, msgConfirmacao: true,
        },
        {
          step: 3, form: { accepted_terms: false }, possuiValidacao: true, msgConfirmacao: false,
        },
      ],
      snackBar: {
        message: '',
        color: 'success',
        timeout: 6000,
        show: false,
      },
      snackBarMensagens: {
        error: 'Tente novamente mais tarde.',
        sucesso: 'Conta bancária adicionada.',
      },
    };
  },

  computed: {
    concordoTermos() {
      return this.quantDePassos[2].form.accepted_terms;
    },
  },

  watch: {
    passoAtual() {
      this.montarObjeto();
    },

    concordoTermos() {
      this.montarObjeto();
    },
  },

  methods: {
    ativarPasso(dadosForm, indexArray) {
      this.quantDePassos[indexArray].possuiValidacao = !dadosForm.validado;
      this.quantDePassos[indexArray].form = dadosForm.form;
      if (indexArray === 2 && dadosForm.validado) {
        this.montarObjeto();
      }
    },

    montarObjeto() {
      if (this.passoAtual === 3 && this.concordoTermos) {
        const passoUm = this.quantDePassos[0].form;
        const passoDois = this.quantDePassos[1].form;
        const passoTres = this.quantDePassos[2].form;
        Object.assign(this.dadosConta, passoUm, passoDois, passoTres);
      }
    },

    respostaApi(success, error = null) {
      if (success) {
        this.setSnackbar(this.snackBarMensagens.sucesso);
      } else {
        this.setSnackbar(error, 'error');
      }
    },

    setSnackbar(mensagem, status = 'success', timeout = 6000) {
      this.snackBar.message = mensagem;
      this.snackBar.color = status;
      this.snackBar.timeout = timeout;
      this.snackBar.show = true;
    },

    redirecionaLista(value) {
      this.snackBar.show = value.visible;

      if (this.snackBar.color === 'success') {
        this.$router.push('/meu-perfil/contas-bancarias');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/scss/botoes-fixos.scss';
</style>
